import React, { Component } from "react";
import CommonUtil from "../../../utils/CommonUtil";
import Breadcrumbs from "./Breadcrumbs";

class BreadcrumbsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      breadcrumbs: []
    };

    this.breadcrumbPosition = -1;
  }

  push = (path, name, shouldRestart = false) => {
    const breadcrumb = { path: path, name: name };
    var breadcrumbs = shouldRestart ? [] : this.state.breadcrumbs;
    const length = breadcrumbs.length;

    if (length === 0 || (length > 0 && breadcrumbs[length - 1].path !== path)) {
      if (
        CommonUtil.arrayContainsObjectWithProperty(breadcrumbs, "path", path)
      ) {
        this.pop(path, name);
      } else {
        breadcrumbs.push(breadcrumb);
        this.setState({ breadcrumbs: breadcrumbs });
      }
    }
  };

  restart = (path, name) => {
    this.push(path, name, true);
  };

  refresh = (path, name) => {
    var breadcrumbs = this.state.breadcrumbs;

    if (breadcrumbs.length > 0) {
      for (var i = 0; i < breadcrumbs.length; i++) {
        if (breadcrumbs[i].path === path) {
          breadcrumbs[i].name = name;
        }
      }

      this.setState({ breadcrumbs: breadcrumbs });
    } else {
      this.push(path, name);
    }
  };

  pop = (path, name) => {
    var breadcrumbs = this.state.breadcrumbs;
    var deleteIndex = -1;

    if (path !== undefined) {
      if (
        this.breadcrumbPosition > -1 &&
        breadcrumbs[this.breadcrumbPosition].path === path
      ) {
        deleteIndex = this.breadcrumbPosition + 1;
        this.breadcrumbPosition = -1;
      } else if (this.breadcrumbPosition === -1) {
        deleteIndex =
          CommonUtil.lastIndexOfObjectWithPoperty(breadcrumbs, "path", path) +
          1;
      }
    } else if (path === undefined) {
      deleteIndex = breadcrumbs.length - 1;
    }

    if (deleteIndex > -1) {
      CommonUtil.removeAllFromArrayAfterIndex(breadcrumbs, deleteIndex);

      if (deleteIndex === 0) {
        breadcrumbs.push({ path: path, name: name });
      }
      this.setState({ breadcrumbs: breadcrumbs });
    }
  };

  position = path => {
    const breadcrumbs = this.state.breadcrumbs;
    const breadcrumbIndex = CommonUtil.lastIndexOfObjectWithPoperty(
      breadcrumbs,
      "path",
      path
    );
    return breadcrumbs.length - 1 - breadcrumbIndex;
  };

  onClick = (breadcrumb, breadcrumbPosition) => {
    this.breadcrumbPosition = breadcrumbPosition;
    this.props.onClick(breadcrumb.path, breadcrumb.name);
  };

  render() {
    return (
      <Breadcrumbs
        breadcrumbs={this.state.breadcrumbs}
        onClick={this.onClick}
        onHomeClick={this.props.onHomeMenuClick}
      />
    );
  }
}

export default BreadcrumbsContainer;
